import { DeleteRequest, GetRequest, PostRequest, PutRequest } from '../service';

const ControllerName = "AccountManagerOrder"

export const GetAllAMOrders = (link) =>
    GetRequest(ControllerName + link)

export const GetAMSubmittedOrders = () =>
    GetRequest(`${ControllerName}/submitted-requests`)

export const AMAskForQuotation = (requests) =>
    PostRequest(`${ControllerName}/ask-for-quotation`, requests)

export const    GetAMDetails = (brokerPatientId) =>
    GetRequest(`${ControllerName}/getDetails/${brokerPatientId}`)

export const GetAMOrderQuotationDetials = (medicalOrderId) =>
    GetRequest(`${ControllerName}/getQuotationDetails/${medicalOrderId}`)


export const GetAMOrderProviderQuotationResponseDetails = (hospitalRequestId) =>
    GetRequest(`${ControllerName}/getProviderQuotationResponseDetails/${hospitalRequestId}`)

// export const AMAcceptQuotation = (hospitalOrderId ,requestData) =>
//     PutRequest(`${ControllerName}/acceptQuotation/${hospitalOrderId}`,requestData)


export const AMAcceptQuotation = (OrderId) =>
    PutRequest(`${ControllerName}/finalize-request-quotation/${OrderId}`)

export const AMGetLookups = () =>
    GetRequest(`${ControllerName}/account-manager-provider-lookup`)



export const AddMissingDataMessage = (PatientId,message)=>
    PutRequest(`${ControllerName}/ask-for-missing-data/${PatientId}`,{message})


